import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-market-icon",
  "use": "icon-market-icon-usage",
  "viewBox": "0 0 40 39",
  "content": "<symbol viewBox=\"0 0 40 39\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-market-icon\">\n<path d=\"M20 0L0 8.94142V39H13.4241V24.2387H26.5759V39H40V8.94142L20 0Z\" fill=\"#E1EAFB\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol